import { faPlusCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { ListGroup } from 'react-bootstrap-5';

const LIQUID_TEMPLATES_OWNER = [
  { label: 'Owner Full Name', value: '{{contact_full_name}}' },
  { label: 'Owner First Name', value: '{{contact_first_name}}' },
  { label: 'Owner Last Name', value: '{{contact_last_name}}' },
  { label: 'Owner Address', value: '{{contact_address}}' },
  { label: 'Owner City', value: '{{contact_city}}' },
  { label: 'Owner State', value: '{{contact_state}}' },
  { label: 'Owner Zip', value: '{{contact_zip}}' },
  { label: 'Property Street Address', value: '{{property_street_address}}' },
  { label: 'Property City', value: '{{property_city}}' },
  { label: 'Property State', value: '{{property_state}}' },
  { label: 'Property Zip', value: '{{property_zip}}' },
  { label: 'Other Owner Full Name', value: '{{contact_full_name_2}}' },
  { label: 'Other Owner First Name', value: '{{contact_first_name_2}}' },
  { label: 'Other Owner Last Name', value: '{{contact_last_name_2}}' },
  { label: 'Mailing Unit Number', value: '{{mailing_unit_no}}' },
];

export const LIQUID_TEMPLATES_ACCOUNT = [
  { label: 'Date', value: '{{date}}' },
  { label: 'Company Name', value: '{{company_name}}' },
  { label: 'Full Name', value: '{{my_name}}' },
  { label: 'First Name', value: '{{first_name}}' },
  { label: 'Last Name', value: '{{last_name}}' },
  { label: 'Address', value: '{{address}}' },
  { label: 'Phone Number', value: '{{phone_number}}' },
  { label: 'Email Address', value: '{{email_address}}' },
];

type MailersTemplatesLiquidProps = {
  updateBody: (liquid: string) => void;
}

export default function MailersTemplatesLiquid({ updateBody }: MailersTemplatesLiquidProps) {

  return (
    <div className="d-flex flex-column py-4 gap-2 h-100">
      <div className="d-flex flex-column flex-fill gap-2" style={{ minHeight: 0 }}>
        <span className="fs-large">Property/Owner Fields</span>
        <div className="d-flex flex-column overflow-auto flex-fill border rounded">
          <ListGroup>
            {LIQUID_TEMPLATES_OWNER.map((template, index) => (
              <ListGroup.Item
                action
                className={`border-0 d-flex flex-grow-1 align-items-center ${index === LIQUID_TEMPLATES_OWNER.length - 1 ? '' : 'border-bottom'}`}
                key={template.value}
                onClick={() => updateBody(template.value)}
              >
                <FontAwesomeIcon className="me-2" color="#2042A7" icon={faPlusCircle} />
                {template.label}
              </ListGroup.Item>
            ))}
          </ListGroup>
        </div>
      </div>
      <div className="d-flex flex-column flex-fill gap-2" style={{ minHeight: 0 }}>
        <span className="fs-large">Account Fields</span>
        <div className="d-flex flex-column overflow-auto flex-fill border rounded">
          <ListGroup>
            {LIQUID_TEMPLATES_ACCOUNT.map((template, index) => (
              <ListGroup.Item
                action
                className={`border-0 d-flex flex-grow-1 align-items-center ${index === LIQUID_TEMPLATES_ACCOUNT.length - 1 ? '' : 'border-bottom'}`}
                key={template.value}
                onClick={() => updateBody(template.value)}
              >
                <FontAwesomeIcon className="me-2" color="#2042A7" icon={faPlusCircle} />
                {template.label}
              </ListGroup.Item>
            ))}
          </ListGroup>
        </div>
      </div>
    </div>
  );
}
